import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Container } from "reactstrap";
import { Button } from "react-bootstrap";
import { getDatabase, ref, query, orderByChild, onValue } from "firebase/database";
import Loader from "../../Component/Loader";
import userProfile from "../../assets/images/noImage.png";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { fetchUserInfo } from "./Slice/ChatSlice";
import { agent } from "../../utils/agent";
import * as API from "../../utils/apiPath";

function RoomList(props) {
  const { userInfo, roomKey } = props;
  const [userRoom, setUserRoom] = useState([]);
  const [showLoading, setShowLoading] = useState(true);
  const history = useNavigate();
  const dispatch = useDispatch();
  const [userImages, setUserImages] = useState({});

  const snapshotToArrayRoom = (snapshot) => {
    const returnArr = [];
    snapshot.forEach((childSnapshot) => {
      const item = childSnapshot.val();
      item.key = childSnapshot.key;
      returnArr.push(item);
    });
    return returnArr;
  };

  useEffect(() => {
    if (!userInfo?.id) return;

    const db = getDatabase();
    const userRoomRef = query(ref(db, `users/${userInfo.id}`), orderByChild("epoch"));

    const unsubscribe = onValue(userRoomRef, (snapshot) => {
      if (snapshot.exists()) {
        const rooms = snapshotToArrayRoom(snapshot);
        setUserRoom(rooms);
      } else {
        setUserRoom([]);
      }
      setShowLoading(false);
    });

    // Cleanup listener on unmount
    return () => unsubscribe();
  }, [userInfo]);

  const enterChatRoom = (item) => {

    const key = item?.key;

    if (!key || typeof key !== "string") {
      console.error("Invalid room key:", key);
      return;
    }

    // SELECT OTHER USER ID
    const selectedUserId =
      userInfo.id === item.mentee_id
        ? item.mentor_id
        : item.mentee_id;

    dispatch(fetchUserInfo(selectedUserId));

    document
      .getElementById("OnscrollBody")
      .classList.add("chatbodyclass");

    history(
      `/chat?roomKey=${key}&userId=${selectedUserId}`
    );
  };

  const bodyClassFalse = (e) => {
    e.preventDefault();
    document.getElementById("OnscrollBody").classList.remove("chatbodyclass");
  };

  useEffect(() => {
    const loadUserImages = async () => {
      if (!userRoom.length) return;

      const images = {};

      await Promise.all(
        userRoom.map(async (item) => {
          console.log("Loading image for room:", item);
          const otherUserId =
            Number(userInfo?.id) == Number(item.mentor_id)
              ? item?.mentee_id
              : item?.mentor_id;

          try {
            const response = await agent.get(
              `${API.GETUSERDATA}/${otherUserId}`
            );

            const userData = response?.data?.data || {};

            images[otherUserId] =
              userData.profile_image ||
              userData.image ||
              userData.user_image ||
              userData.profile_pic ||
              userData.avatar ||
              "";
          } catch (error) {
            console.error(
              "Failed loading image for user:",
              otherUserId,
              error
            );
          }
        })
      );

      setUserImages(images);
    };

    loadUserImages();
  }, [userRoom, userInfo.id]);

  const renderChatList = () => {
    return userRoom.map((item, idx) => {
      const otherUserId =
        Number(userInfo.id) === Number(item.mentor_id)
          ? item.mentee_id
          : item.mentor_id;

      // const profileImageFinal =
      //   Number(userInfo.id) === Number(item.mentor_id)
      //     ? item?.mentee_image ||
      //     userImages[otherUserId] ||
      //     userProfile
      //     : item?.mentor_image ||
      //     userImages[otherUserId] ||
      //     userProfile;

      const profileImageFinal =
        Number(userInfo.id) === Number(item.mentor_id)
          ? userImages[otherUserId] ||
          item?.mentee_image ||
          userProfile
          : userImages[otherUserId] ||
          item?.mentor_image ||
          userProfile;

      return (
        <li key={item.key} className={item.key === roomKey ? "chatActive" : ""}>
          <button
            type="button"
            className="chat-list-button"
            onClick={() => enterChatRoom(item)}
          >

            <div className="usr-msg-details">
              <div className="usr-ms-img">
                <img
                  src={profileImageFinal}
                  alt="ListingImage"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = userProfile;
                  }}
                />
              </div>
              {userInfo.id === item.mentee_id ? (
                <div className="usr-mg-info">
                  <h3>{item.mentor_name}</h3>
                  <p className="text-truncate truncate" style={{ maxWidth: "235px" }}>
                    {item.message}
                  </p>
                </div>
              ) : (
                <div className="usr-mg-info">
                  <h3>{item.mentee_name}</h3>
                  <p className="text-truncate truncate" style={{ maxWidth: "235px" }}>
                    {item.message}
                  </p>
                </div>
              )}
              <div className="chat-meta">
                <span className="posted_time">{item.time}</span>
              </div>
            </div>
          </button>
        </li>
      )
    })
  };

  useEffect(() => {
    // If user already opened a room manually, do nothing
    if (roomKey || !userRoom.length || !userInfo?.id) return;

    const firstRoom = userRoom[0];

    if (!firstRoom) return;

    const selectedUserId =
      Number(userInfo.id) === Number(firstRoom.mentee_id)
        ? firstRoom.mentor_id
        : firstRoom.mentee_id;

    dispatch(fetchUserInfo(selectedUserId));

    history(
      `/chat?roomKey=${firstRoom.key}&userId=${selectedUserId}`,
      { replace: true }
    );
  }, [userRoom, roomKey, userInfo, dispatch, history]);

  return (
    <>
      <div className="form-group mt-3 text-left">
        <Button
          className="btn backbtn outline me-2"
          onClick={bodyClassFalse}
        >
          <i className="fas fa-times"></i>
        </Button>
      </div>

      <div className="jumbotron_leftsec">
        {showLoading && <Loader />}
        <Container className="custom-jumbotron">
          <ul>{renderChatList()}</ul>
        </Container>
      </div>
    </>
  );
}

RoomList.propTypes = {
  userInfo: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
  roomKey: PropTypes.string,
};

export default RoomList;
